import util from '@bmp-vue/core/api/util'

const controller = 'UserAdmin'
export default Object.assign({}, util.GetCrud(controller, null), {
  PostUserRoles: function (dto) {
    return util.Axios.Post(`${controller}/${dto.userName}/roles`, dto)
  },
  PostUserClaims: function (dto) {
    return util.Axios.Post(`${controller}/${dto.userName}/claims`, dto)
  },
  DeleteUserExternalLogin: function (username, dto) {
    return util.Axios.Delete(`${controller}`, `${username}/logins?loginProvider=${dto.loginProvider}&providerKey=${dto.providerKey}`)
  },
  PostFidoU2fCreationOptions: function (userName) {
    return util.Axios.Post(`${controller}/${userName}/FidoU2fCreationOptions`, null)
  },
  PostFidoU2fRegister: function (username, attestationResponse) {
    var request = { AssertionResponse: attestationResponse }
    return util.Axios.Post(`${controller}/${username}/FidoU2fRegister`, request)
  },
})
